import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductcardComponent } from './productcard.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [
    ProductcardComponent
  ],
  entryComponents: [
    ProductcardComponent
  ],
  exports: [
    ProductcardComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatListModule,
    MatSelectModule,
    MatDialogModule,
    MatTooltipModule
  ]
})
export class ProductcardModule { }
